let observerRunning = false;
const config = {
  childList: true,
  subtree:true
}

function verifyReviews(){
  const rowProfiles = document.querySelectorAll('.jdgm-rev__author-wrapper');
  const profIcons = document.querySelectorAll('.jdgm-rev');
  
  for(let i=0; i<rowProfiles.length;i++){
  const verifyBadge = rowProfiles[i].querySelector('.jdgm-rev__buyer-badge-wrapper');
  if(verifyBadge)return;
  const newElement = document.createElement('span');
  const childElement = document.createElement('span');
  newElement.classList.add('jdgm-rev__buyer-badge-wrapper'); 
  childElement.classList.add('jdgm-rev__buyer-badge');
  newElement.appendChild(childElement);
  rowProfiles[i].appendChild(newElement);
  profIcons[i].setAttribute('data-verified-buyer','true');
  }
}



document.addEventListener('DOMContentLoaded', () => {
    const revWid = document.querySelector('.jdgm-rev-widg__body');
    if (revWid) {
        const observer = new MutationObserver(() => {
            if (observerRunning) return;
            observerRunning = true;
            verifyReviews();

            setTimeout(() => {
                observerRunning = false;
            }, 1000);
        });
        observer.observe(revWid, config);
    }
});